import { c as _c } from "react/compiler-runtime";
import { AppearanceProvider } from '@onefootprint/appearance';
import { QueryClientProvider } from '@tanstack/react-query';
import type { AppProps } from 'next/app';
import type React from 'react';
import configureI18n from '../../config/initializers/i18next';
import queryClient from '../../config/initializers/react-query';
import MachineProvider from '../machine-provider';
const Providers = t0 => {
  const $ = _c(3);
  const {
    children,
    pageProps
  } = t0;
  const {
    language
  } = pageProps;
  configureI18n({
    language: language ?? "en"
  });
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      strategy: ["styleParams"]
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <QueryClientProvider client={queryClient}><MachineProvider><AppearanceProvider options={t1}>{children}</AppearanceProvider></MachineProvider></QueryClientProvider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default Providers;